module.exports = __webpack_public_path__ + "img/icon2.969e8b0a.png";